import { StateProvider, StateService } from "@uirouter/angularjs/lib-esm"
import { vsName as menuServiceName, MenuService } from "../menu/provider/MenuService";

export function routeConfig($stateProvider: StateProvider) {
  $stateProvider.state({
    name: 'findPage',
    url: '/redirect',
    onEnter: redirectToSuitablePage
  })
}
routeConfig.$inject = ['$stateProvider']

function redirectToSuitablePage(menuService: MenuService, $state: StateService) {
  const menuItems = menuService.getMenuItems()
  if (menuItems.length === 0) {
    throw new Error('User has no access.  Please contact administrator')
  }
  $state.go(menuItems[0].getState())
}
redirectToSuitablePage.$inject = [menuServiceName, '$state']